import axios from "../../../config/axiosConfig";

// Misma búsqueda de servicios activos que usa la pantalla de facturación.
export const buscarServiciosParaFacturar = (buscar) => axios.get("/api/facturas/buscar", { params: { buscar } });
export const getCatalogosFacturaManual = () => axios.get("/api/factura-manual/catalogos");
export const getDatosClienteFactura = (id) => axios.get(`/api/factura-manual/cliente/${id}`);
export const crearFacturaManual = (body) => axios.post("/api/factura-manual", body);
export const listarFacturasManuales = (params) => axios.get("/api/factura-manual", { params });
export const anularFacturaManual = (cod) => axios.post(`/api/factura-manual/${cod}/anular`);
